import { Injectable, Injector } from '@angular/core';

import { SummaryService } from './summary.service';
import { TripsService } from './trips.service';
import { BaseReportService } from './reportBase.service';
import type { TTicket, IGetReportData, TReportOptions } from '@shared/models';

@Injectable()
export class ReportTicketDetailService extends BaseReportService implements IGetReportData {
    private summaryService: SummaryService;
    private tripsService: TripsService;

    constructor(injector: Injector) {
        super(injector);
        this.tripsService = injector.get(TripsService);
        this.summaryService = injector.get(SummaryService);
    }

    public async getReportData(): Promise<any> {
        const startingDate = this.options.startingDate;
        const endingDate = this.options.endingDate;
        let numTickets = 0;
        let reportColValues: any;
        const allRows: any[] = [];

        const obj = await this.summaryService.getTripsByDateRange(startingDate!, endingDate!);
        const tripUids = obj.uids as string[];
        const trips = await this.tripsService.getTrips(tripUids);

        for (const trip of trips) {
            // console.log('trip.uid = ' + trip.uid);
            const driver = trip.driver;

            trip.tickets.forEach((ticket: TTicket) => {
                const createdDate = this.formatDateTime(ticket.createdDate!);
                const completedDate = this.formatDateTime(ticket.completedDate!);
                const duration = this.dateService.formatDuration(ticket.createdDate!, ticket.completedDate!);

                const location = (ticket.fromDealership ? ticket.dropoff!.locationName : ticket.pickup!.locationName);
                const serviceAdvisor = ticket.serviceAdvisor || ' ';
                // const driver = ticket.driver || ' ';
                // const shuttleName = 'fixme'; //ticket.shuttle.shuttleName;

                reportColValues = [createdDate, completedDate, duration, location, serviceAdvisor, driver];
                const rowInfo = this.buildRowInfo(reportColValues, 'data');
                allRows.push(rowInfo);
                ++numTickets;
            });
        }

        // Tack on the summary totals.
        allRows.push(this.buildRowInfo(['Tickets: ' + numTickets.toString()], 'data', 'subtotal'));
        allRows.push(undefined);

        const reportData = { 'data': allRows };
        return reportData;
    }
}
